// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { GetPreferredPackageVersionResponse } from '@digitalasset/json-api-ts-client/index';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PackageName } from '../../config/package';
import { useLedgerApiClient } from '../../contexts/LedgerApiContext';
import { useParties } from '../../contexts/PartiesContext';

export const useGetPreferredPackageVersion: (
  packageName: PackageName,
) => UseQueryResult<GetPreferredPackageVersionResponse, string> = (packageName: PackageName) => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();
  return useQuery({
    refetchInterval: false,
    queryKey: ['queryPreferredPackageVersion', operator, party, packageName],
    enabled: !!operator,
    queryFn: async () => {
      return ledgerApi.getPreferredPackageVersion(packageName, operator, party);
    },
  });
};
